import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  dialog: {
    width: '567px',
    maxWidth: 'calc(100% - 32px)',
    height: 'auto',
    margin: 0,
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    overflow: 'hidden',
    borderRadius: '4px',
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 11px 15px 0px rgba(0,0,0,0.2), 0px 9px 46px 0px rgba(0,0,0,0.12), 0px 24px 38px 0px rgba(0,0,0,0.14)',
  },
  title: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 !important',
    paddingRight: '32px !important',
    minHeight: 0,
    flex: '0 0 auto',
    '& .myev-MuiTypography-h3': {
      fontSize: '18px',
      fontWeight: 600,
      lineHeight: '27px',
      color: theme.evPalette.charcoal[900],
      textTransform: 'none',
    },
  },
  closeButton: {
    position: 'absolute',
    top: 0,
    right: 0,
    cursor: 'pointer',
    fontSize: '20px',
    color: theme.evPalette.charcoal[700],
  },
  content: {
    padding: '0 !important',
    margin: 0,
    flex: '0 0 auto',
    overflow: 'visible',
  },
  message: {
    margin: 0,
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    color: theme.evPalette.charcoal[900],
  },
  formLink: {
    color: theme.evPalette.charcoal[800],
    textDecoration: 'underline',
    cursor: 'pointer',
    '&:hover': {
      color: theme.evPalette.charcoal[900],
    },
  },
  actions: {
    padding: '0 !important',
    margin: 0,
    minHeight: 0,
    flex: '0 0 auto',
    justifyContent: 'flex-end',
    '&>button': {
      textTransform: 'none',
      fontSize: '16px',
    },
  },
  tryAgainButton: {
    minWidth: 0,
    height: '44px',
    padding: '10px 16px',
    backgroundColor: theme.evPalette.ocean[600],
    color: '#FFFFFF',
    '&:hover': {
      backgroundColor: theme.evPalette.ocean[700],
    },
  },
}));
